import React, { Component, } from 'react'

import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import PropTypes from 'prop-types'

import {CCIcon} from './../../cc-imports'
import './cc-back-layout.css'
import './../../styles/css/layout/CCBackLayout/cc-back-layout.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";

class CCBackLayout extends Component {

  static propTypes = {
      onBackPress : PropTypes.func
  }

  static defaultProps = {
      scrollable : true
  }

  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
      return (
          <CCErrorBoundary>
          <div className={"flex-container"} style={{...{flex:1}, ...this.props.style}}>
                  <div className={"flex-container parent2"} style={{ ...this.props.style}}>
                      <CCIcon type={'back'} className={'cc-back-icon b-icon'} onPress={this.props.onBackPress} style={{}}/>
                  </div>
              {
                  this.props.children
              }
          </div>
          </CCErrorBoundary>
    )
  }
}


export default connect(state => ({
        user : state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({}, dispatch),
        dispatch: dispatch
    })
)(CCBackLayout);



// WEBPACK FOOTER //
// ./src/app/layout/CCBackLayout/CCBackLayout.js